export default "__VITE_ASSET__CmpPZ_az__"